import { PLATFORM } from "aurelia-framework";

export const CommonUiDialogConstants = {
    DialogAttachments: PLATFORM.moduleName("../dialogs/dialog-attachments/dialog-attachments"),
    ObjectViewer: PLATFORM.moduleName("@rightship-tech/common-ui/components/comp-object-viewer/comp-object-viewer"),
    ImageViewer: PLATFORM.moduleName("@rightship-tech/common-ui/components/comp-image-viewer/comp-image-viewer")
}